import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import FileSaver from 'file-saver';
import { AppService } from 'src/app/app.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';

@Component({
    selector: 'app-table-simple-v2',
    templateUrl: './table-simple-v2.component.html',
    styleUrls: ['./table-simple-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableSimpleV2Component implements OnInit {

  @Input() configData;
  @Input() data;

  tableData = [];
  isLoading = false;

  constructor(private modalService: ModalService, private appService: AppService) {}

  ngOnInit() {
    this.tableData = this.data || [];
  }
  
  normalView() {
    document.getElementById("overlay").style.display = "none";
  }

  columnAction(column, data){
    let apiUrl = column['apiUrl'];    
    sessionStorage.setItem('docId', data['documentId']);
    let res;

    this.isLoading = true;
    apiUrl =`/visibility-service/external/cox/_invokeApi?configurationKey=EDOC_DOWNLOAD&documentId=${sessionStorage.getItem('docId')}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}&action=downloadFile`;
    this.appService.makeHttpDocRequest(apiUrl).subscribe(response => { 
      res = response;     
      this.normalView();
      this.isLoading = false;
      let fileName = "Orders_status ";
      fileName += this.appService.getCurrentDateAndTime();

      FileSaver.saveAs(res, fileName );

    }, async (err) => {
      this.normalView();
      this.isLoading = false;

      const message = err.message;

      let modal = new Modal({
        action: false, name: 'download', title: 'Download File', description: message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.status);

      console.log(err);
    })
  }

}
